<div id="main-container"
     *ngrxLet="authService.isAuthenticated$; let isAuthenticated"
     [ngClass]="{'devMode': !prod }"
     appGxSnowfall
     [enable]="isChristmasSeason()"
     [snowfallDensity]="30">
  @if (isAuthenticated && navigation) {
    <app-navigation [@toggleNavigation]></app-navigation>
  }


  <div id="navigation-toggle"
       matTooltip="{{ navigation ? ('HIDE_NAV_BAR' | translate) : ('SHOW_NAV_BAR' | translate) }}"
       (click)="toggleNavigation()"
       [ngClass]="{'navShown': navigation, 'navHidden': !navigation}">
    <mat-icon svgIcon="chevron_left"
              class="text-neutral-40"></mat-icon>
  </div>


  <!--  min-w-0 because otherwise, min-w-auto is applied = min content size which would cut off right
  side-navs; grow since there is fix-width app-navigation!  -->
  <div class="flex grow flex-col min-w-0">

    <div id="page-content">

      <router-outlet></router-outlet>

      <ng-container *ngrxLet="consent$; let consent;">
        @if (!consent) {
          <app-consent-banner
              @bannerSlideIn
                            [ngClass]="{ 'w-[calc(100%-64px)]': navigation,
                                       'w-full': !navigation,
                                       'left-[64px]': navigation,
                                       'left-0': !navigation }"
              class="fixed bottom-0 left-[64px] z-[999]"></app-consent-banner>
        }
      </ng-container>
    </div>
  </div>


  @if (showFeedbackButton$ | ngrxPush) {
    <app-feedback-button/>
  }
</div>
